import { Flex, Stack, VStack } from "@chakra-ui/react";
import { Heading18 } from "components/Heading";
import { useCallback } from "react";
import { UseFormReturn, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { PrimaryButton, SecondaryButton } from "components/Button";
import { Text12 } from "components/Text";
import SchedulingParameters from "../Timing/SchedulingParameters";
import { occurrenceSelectionSchema, OccurrenceSelectionSchema } from "./schema";

export default function OccurrenceSelectionForm({
  form: parentForm,
  onClose,
}: { form: UseFormReturn<any>, onClose: () => void }) {
  // Create child form with its own schema
  const childForm = useForm<OccurrenceSelectionSchema>({
    resolver: yupResolver(occurrenceSelectionSchema),
    defaultValues: {
      offset: parentForm.getValues("offset") || 0,
      referenceEvent: parentForm.getValues("referenceEvent") || "start_date",
      offsetUnit: parentForm.getValues("offsetUnit"),
    },
  });

  const {
    setValue,
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = childForm;

  const onSubmit = useCallback((values: OccurrenceSelectionSchema) => {
    // Propagate validated values to parent form
    Object.entries(values).forEach(([key, value]) => {
      parentForm.setValue(key as any, value, { shouldDirty: true });
    });
    onClose();
  }, [parentForm, onClose]);

  const onError = useCallback((validationErrors: any) => {
    console.error("Occurrence selection validation failed", validationErrors);
  }, []);

  const [offset, referenceEvent] = watch(["offset", "referenceEvent"]);
  return (
    <Stack py="6" p="2">
      <Heading18 mb={4}>Occurrence Selection</Heading18>

      <VStack spacing="16px" alignItems="stretch">
        <Text12>The earliest in a new hire&apos;s journey an occurrence should be chosen</Text12>
        <SchedulingParameters
          label="Not Before"
          excludeBeforeStartDate
          offset={offset || 0}
          referenceEvent={referenceEvent}
          setValue={setValue}
          control={control as any}
          errors={errors}
        />
      </VStack>

      <Flex pt="4" w="100%" justify="flex-end" gap="2">
        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
        <PrimaryButton onClick={handleSubmit(onSubmit, onError)}>Save</PrimaryButton>
      </Flex>
    </Stack>
  );
}
